import { useMemo } from 'react';
import { InternalApiEntityType, InternalApiCustomListSignificantFields } from '../../api-internal';
import { useQueryCustomListSignificantFields } from './customListSuiActions';

export const hasListMissingSui = (
  listId: string,
  personFields?: InternalApiCustomListSignificantFields,
  transactionFields?: InternalApiCustomListSignificantFields
): boolean => {
  const personConfig = personFields?._configuration.find((c) => c.listId === listId);
  const transactionConfig = transactionFields?._configuration.find((c) => c.listId === listId);
  const hasPersonFields = (personConfig?.fields?.length ?? 0) > 0;
  const hasTransactionFields = (transactionConfig?.fields?.length ?? 0) > 0;
  return !hasPersonFields || !hasTransactionFields;
};

export const useCustomListSuiWarnings = (listIds: string[]) => {
  const { data: personFields, isLoading: isPersonLoading } = useQueryCustomListSignificantFields(
    InternalApiEntityType.PERSON
  );
  const { data: transactionFields, isLoading: isTransactionLoading } = useQueryCustomListSignificantFields(
    InternalApiEntityType.TRANSACTION
  );

  const isLoading = isPersonLoading || isTransactionLoading;

  const listIdsWithMissingSui = useMemo(() => {
    if (!personFields || !transactionFields) {
      return new Set<string>();
    }

    const missingIds = new Set<string>();
    listIds.forEach((listId) => {
      if (hasListMissingSui(listId, personFields, transactionFields)) {
        missingIds.add(listId);
      }
    });

    return missingIds;
  }, [personFields, transactionFields, listIds]);

  return { isLoading, listIdsWithMissingSui };
};
